export const businessCategories = [
  {
    nombre: "Bares",
    id: "123456789",
    subcategories: [],
  },
  {
    id: "321654987",
    nombre: "Discotecas",
    subcategories: [],
  },
  {
    id: "9517532684",
    nombre: "Gastrobar",
    subcategories: [],
  },

  {
    id: "789453132",
    nombre: "Restaurante",
    subcategories: [],
  },
  {
    id: "686565651",
    nombre: "Otros",
    subcategories: [],
  },
];

export const ASC = "asc";
export const DESC = "desc";
/*
    "BRICOLAJE_JARDÌN": "Bricolaje y Jardìn",
    "OTRO": "Otro"*/
